import { Injectable } from '@angular/core';

const THEME_KEY = 'theme';
const DARK_CLASS = 'dark-theme';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    isDarkMode = false;

    initialize(): void {
        const saved = localStorage.getItem(THEME_KEY);
        this.isDarkMode = saved === 'dark';
        this.applyTheme();
    }

    toggleTheme(): void {
        this.isDarkMode = !this.isDarkMode;
        localStorage.setItem(THEME_KEY, this.isDarkMode ? 'dark' : 'light');
        this.applyTheme();
    }

    private applyTheme(): void {
        const mode = this.isDarkMode ? 'dark' : 'light';
        document.body.setAttribute('data-color-mode', mode);
        document.body.classList.toggle(DARK_CLASS, this.isDarkMode);
    }
}
